export default "__VITE_ASSET__e54ed8a5__"